// This file contains the core view-switching logic for the single-page application.

import * as $store from '@/store'
import {
  authView, analysisView, konfigurasiView,
  plAnalysisView, mainMenuview, salesDashboardView, pnlHistoryView, pnlComparisonView, premiumAnalysisView,
} from './ui'
import { currentView, setCurrentView, currentUserRole } from './state'
import { setupConfigurationTab } from '@/config/gemini'
import { setupPremiumAnalysisView } from '@/analysis/premium/orchestrator'
import { populateDataHubBranchSelector } from '../uploads/branch-selector'
// --- [JOB_13] REMOVE THIS IMPORT ---
// import { initializeBrandManagement } from '@/brands/brand-management'


/**
 * Displays a specific application view while hiding all others.
 * It also handles role-based access for admin views and triggers necessary data loads.
 */
export function showView(viewName: string): void {
  // Reset analysis state when leaving the analysis view to prevent data leakage between sessions.
  if (currentView === 'analysis' && viewName !== 'analysis') {
    console.debug(`Leaving analysis view (${currentView} → ${viewName}), resetting analysis state`)
    $store.resetAnalysisState()
  }

  setCurrentView(viewName)

  // Hide all views first to ensure a clean slate.
  const brandManagementView = document.getElementById('brand-management-view')
  const createBrandGateView = document.getElementById('create-brand-gate-view') 

  const allViews = [
    authView, mainMenuview, salesDashboardView, analysisView,
    konfigurasiView, plAnalysisView,
    pnlHistoryView, pnlComparisonView, premiumAnalysisView,
    brandManagementView,
    createBrandGateView, 
  ]
  allViews.forEach((v) => v?.classList.add('hidden'))

  // A map for simple view lookups.
  const viewMap: Record<string, HTMLElement | null> = {
    'auth': authView,
    'main-menu': mainMenuview,
    'sales-dashboard': salesDashboardView,
    'pl-analysis': plAnalysisView,
    'analysis': analysisView,
    'pnl-history': pnlHistoryView,
    'pnl-comparison': pnlComparisonView,
    'premium-analysis': premiumAnalysisView,
    'brand-management': brandManagementView,
    'create-brand-gate': createBrandGateView,
  }

  if (viewMap[viewName]) {
    // --- [JOB_13] THIS IS THE FIX ---
    // 1. We make the view visible
    viewMap[viewName]?.classList.remove('hidden')
    
    // 2. ALL "SMART" LOGIC IS REMOVED.
    //    We are no longer calling initializeBrandManagement() here.
    // --- [END FIX] ---

    populateDataHubBranchSelector()

    // UPDATED: Call the new setup function for the premium view
    if (viewName === 'premium-analysis') {
      setupPremiumAnalysisView()
    }
  } else if (viewName === 'konfigurasi') {
    // Handle another admin-only view.
    if (currentUserRole === 'admin') {
      konfigurasiView?.classList.remove('hidden')
      setupConfigurationTab()
    } else {
      console.warn(`[showView] Non-admin user tried to access 'konfigurasi' view.`)
      // Fallback to main menu if unauthorized
      mainMenuview?.classList.remove('hidden')
      setCurrentView('main-menu')
    }
  } else {
    console.warn(`[showView] View not found: ${viewName}, defaulting to auth view.`)
    authView?.classList.remove('hidden')
    setCurrentView('auth')
  }
}